module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_5012.b5001d57.png";